import { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import LayoutGeneral from "../LayoutGeneral";
import { RUTAS_BITACORAS } from "../Rutas";
import "./BitacoraNueva_Seguimiento.css"; 
import DatePicker from "react-datepicker";

const BitacoraNueva_Seguimiento = () => {
    const navigate = useNavigate();
    // Campos principales
        //Renglon 1
        const idUsuario = localStorage.getItem('idUsuario');
        const nombreUsuario = localStorage.getItem('nombreUsuario');
        const EsAdmin = localStorage.getItem("admin");
        const roles = JSON.parse(localStorage.getItem('roles') || '[]');
        const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
        const [Oficinas, setOficinas] = useState([]);
        const [OficinaSeleccionada, setOficinaSeleccionada] = useState(null);
        const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
        // Renglon 2
        const [Actividades, setActividades] = useState([]);
        const [tipoActividadSeleccionada, setTipoActividadSeleccionada] = useState("");
        const [actividadSeleccionada, setActividadSeleccionada] = useState("");
        const [fechaActividad, setFechaActividad] = useState(null);
        // Renglon 3
        const [agentePromotor, setagentePromotor] = useState(null);
        const [Agentes, setAgentes] = useState([]);
        const [Promotores, setPromotores] = useState([]);
        const [agenteSeleccionado, setAgenteSeleccionado] = useState(null);
        const [promotorSeleccionado, setPromotorSeleccionado] = useState(null);
        const [claveAgente, setClaveAgente] = useState("");
        // Renglon 4
        const [tipoContacto, setTipoContacto] = useState([]);
        const [TipoContactoSeleccionado, setTipoContactoSeleccionado] = useState(null);
        const [motivoContacto, setMotivoContacto] = useState("");
        // Renglon 5
        const [personaContacto, setPersonaContacto] = useState("");
        const [puestoContacto, setPuestoContacto] = useState("");
        // Renglon 6
        const [horaContacto, setHoraContacto] = useState("");
        const [duraciones, setDuraciones] = useState([]);
        const [duracionSeleccionada, setDuracionSeleccionada] = useState(null);
        // Renglon 7-8 (Acuerdos)
        const [mostrarAcuerdo, setMostrarAcuerdo] = useState(true);
        const [tipoAcuerdo, setTipoAcuerdo] = useState([]);
        const [tipoAcuerdoSeleccionado, setTipoAcuerdoSeleccionado] = useState(null);
        const [acuerdos, setAcuerdos] = useState([]);
        const [mensajeAcuerdo, setMensajeAcuerdo] = useState("");
        const [comentarioAcuerdo, setComentarioAcuerdo] = useState("");
        const [fechaCompromisoAgregar, setFechaCompromisoAgregar] = useState(null);
        // Renglon 9
        const [comentarios, setComentarios] = useState("");
        const [errors, setErrors] = useState({});

        const actividadesFiltradas = tipoActividadSeleccionada ? Actividades.filter(act => act.canal === tipoActividadSeleccionada) : [];
        const actividadesOptionales = [4, 5, 7, 8, 10, 11,2,6,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72];
        const actividadActual = Number(actividadSeleccionada);
        const esActividadOpcional = actividadesOptionales.includes(actividadActual);
        const personaSeleccionada = agentePromotor === "1" ? promotorSeleccionado : agentePromotor === "2" ? agenteSeleccionado : null;

    // Función para cerrar sesión
    const cerrarSesion = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("idUsuario");
        localStorage.removeItem("nombreUsuario");
        navigate("/");
    };
    // Redireccionamientos
    const GoHome = () => { navigate("/Home"); };
    const GoUsuarios = () => { navigate("/Usuarios"); };
    const GoBitácoras = () => { navigate("/Bitacoras"); };
    const GoIncidencias = () => { navigate("/Incidencias"); };
    
    // Función para sanitizar texto y escapar caracteres especiales
    const sanitizarTexto = (texto) => {
        if (!texto) return "";
        return String(texto)
            .replace(/\\/g, "\\\\")  // Escapa backslash
            .replace(/"/g, '\\"')     // Escapa comillas dobles
            .replace(/'/g, "\\'")     // Escapa comillas simples
            .replace(/\n/g, "\\n")    // Escapa saltos de línea
            .replace(/\r/g, "\\r")    // Escapa retorno de carro
            .replace(/\t/g, "\\t");   // Escapa tabulaciones
    };

    // Cargar datos iniciales
    useEffect(() => {
        // Traer Agentes
        const fetchAgentes = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_AGENTES);
                const data = await res.json();
                setAgentes(data);
            } catch (error) {
                console.error("Error cargando roles:", error);
            }
        };
        fetchAgentes();

        // Traer Promotores
        const fetchPromotores = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_PROMOTORES);
                const data = await res.json();
                setPromotores(data);
            } catch (error) {
                console.error("Error cargando promotores:", error);
            }
        };
        fetchPromotores();

        // Traer Oficinas
        const fechtOficinas = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_OFICINAS(idUsuario, rolUsuario));
                const data = await res.json();
                setOficinas(data);
            } catch (error) {
                console.error("Error cargando oficinas:", error);
            }
        };
        fechtOficinas();

        // Traer Actividades
        const fetchActividades = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_ACTIVIDADES);
                const data = await res.json();
                setActividades(data);
            } catch (error) {
                console.error("Error cargando actividades:", error);
            }  
        };
        fetchActividades();

        // Traer Tipo de Contacto
        const fetchTipoContacto = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_TIPOCONTACTO);
                const data = await res.json();
                setTipoContacto(data);
            } catch (error) {
                console.error("Error cargando tipo de contacto:", error);
            }  
        };
        fetchTipoContacto();

        // Traer Duración de Contacto
        const fetchDuraciones = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_DURACIONES);
                const data = await res.json();
                setDuraciones(data);
            } catch (error) {
                console.error("Error cargando duraciones:", error);
            }
        };
        fetchDuraciones();

        // Traer Tipo de Acuerdo
        const fetchTipoAcuerdo = async () => {
            try {
                const res = await fetch(RUTAS_BITACORAS.GET_ACUERDOVISITA);
                const data = await res.json();
                setTipoAcuerdo(data);
            } catch (error) {
                console.error("Error cargando tipo de acuerdo:", error);
            }  
        };
        fetchTipoAcuerdo();
    }, []); 

    // Funciones para agregar y quitar acuerdos
    const agregarAcuerdo = () => {
      if (tipoAcuerdoSeleccionado) {
        const acuerdoObj = tipoAcuerdo.find(a => a.idAcuerdo === tipoAcuerdoSeleccionado);
        setAcuerdos([
          ...acuerdos,
          { ...acuerdoObj, comentarioAcuerdo: "", fechaCompromiso: fechaCompromisoAgregar }
        ]);
        setTipoAcuerdoSeleccionado(null);
        setMostrarAcuerdo(false);
        setMensajeAcuerdo("");
        setFechaCompromisoAgregar(null);
      }
    };

    const quitarAcuerdo = (idx) => {
      setAcuerdos(acuerdos.filter((_, i) => i !== idx));
    }; 

    const validateForm = () => {
        const newErrors = {};
        if (!OficinaSeleccionada) newErrors.OficinaSeleccionada = true;
        if (!tipoActividadSeleccionada) newErrors.tipoActividadSeleccionada = true;
        if (!actividadSeleccionada) newErrors.actividadSeleccionada = true;
        if (!esActividadOpcional && !agentePromotor) newErrors.agentePromotor = true;
        if (agentePromotor && agentePromotor !== "0" && !personaSeleccionada) newErrors.personaSeleccionada = true;
        if (!fechaActividad) newErrors.fechaActividad = true;
        if (!TipoContactoSeleccionado) newErrors.TipoContactoSeleccionado = true;
        if (!motivoContacto.trim()) newErrors.motivoContacto = true;
        if (!horaContacto) newErrors.horaContacto = true;
        if (!duracionSeleccionada) newErrors.duracionSeleccionada = true;
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const guardarBitacora = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
            alert("Completa todos los campos obligatorios.");
            return;
        }

        if (acuerdos.length === 0) {
            alert("Debe agregar al menos 1 acuerdo.");
            return;
        }
    
        // Construir el modelo
        const fechaFormateada = fechaActividad ? `${fechaActividad.getFullYear()}-${String(fechaActividad.getMonth()+1).padStart(2,'0')}-${String(fechaActividad.getDate()).padStart(2,'0')} ${horaContacto}` : "";
        const claveSeleccionada = agentePromotor === "1" ? (promotorSeleccionado?.value || "") : agentePromotor === "2" ? (agenteSeleccionado?.value || "") : "";
        const modelo = {
          clave: claveSeleccionada,
          idUsuario: Number(idUsuario),
          idRol: 4,
          idOficina: OficinaSeleccionada,
          claveAgente: claveSeleccionada,
          tipoIntermediario: agentePromotor === "1" ? "1" : agentePromotor === "2" ? "2" : "0",
          idActividad: Number(actividadSeleccionada),
          fechaContacto: fechaFormateada,
          idTipoContacto: TipoContactoSeleccionado ? Number(TipoContactoSeleccionado) : 0,
          motivoContacto: sanitizarTexto(motivoContacto),
          personaContacto: sanitizarTexto(personaContacto),
          puestoContacto: sanitizarTexto(puestoContacto),
          idDuracion: duracionSeleccionada ? Number(duracionSeleccionada) : 0,
          comentario: sanitizarTexto(comentarios),
          estatus: 1,
          fechaCreacion: fechaFormateada,
          fechaCierre: "",
          fechaActualizacion: "",
          numActualizacion: 0,
          acuerdos: acuerdos.map(a => ({
            idBitacora: 0,
            idAcuerdo: a.idAcuerdo,
            descripcion: a.acuerdo,
            estatus: 1,
            comentario: sanitizarTexto(a.comentarioAcuerdo && a.comentarioAcuerdo.trim() !== "" ? a.comentarioAcuerdo : "Sin Comentario"),
            comentarioReapertura: "",
            fechaCompromiso: a.fechaCompromiso ? `${a.fechaCompromiso.getFullYear()}-${String(a.fechaCompromiso.getMonth()+1).padStart(2,'0')}-${String(a.fechaCompromiso.getDate()).padStart(2,'0')}` : ""
          }))
        };

        console.log("Modelo a enviar:", JSON.stringify(modelo));
    
        try {
          const res = await fetch(RUTAS_BITACORAS.REGISTER_BITACORA, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(modelo)
          });
    
          if (res.ok) {
            alert("Bitácora guardada correctamente.");
            navigate("/Bitacoras");
          } else {
            const error = await res.text();
            alert("Error al guardar la bitácora: " + error);
          }
        } catch (error) {
          alert("Error de conexión: " + error.message);
        }
      };
 
    return (
        <LayoutGeneral titulo="BitacoraNueva_Seguimiento"> 
            <div className="home-container">
                <aside className="sidebar">
                <ul>
                    <li onClick={GoHome}><i className="bi bi-house"></i> Inicio</li>
                    {EsAdmin === "1" && (
              <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>
                    )}
                     {puedeVerReporte && (
                            <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
                        )}
                    <li onClick={GoBitácoras}><i className="bi bi-journal"></i> Bitácoras</li>
                    <li className="logout" onClick={cerrarSesion}> <i className="bi bi-box-arrow-right"></i> Cerrar Sesión </li>
                </ul>
                </aside>

                <main className="main-content">
                    <h2>
                        <button className="btn btn-primary mt-3" onClick={GoBitácoras}>
                            Regresar
                        </button>
                        <center> <span> Bitacora de Seguimiento </span> </center>
                    </h2>

                    <form className="nueva-Bitacora-form" onSubmit={guardarBitacora}>
                        {/* Renglon #1 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label>Ejecutivo</label>
                                <input type="text" className="form-control" value={nombreUsuario} readOnly />
                            </div>
                            <div className="col-md-6">
                                <label>Oficinas</label>
                                <select
                                  className={`form-control ${errors.OficinaSeleccionada ? 'is-invalid' : ''}`}
                                  value={OficinaSeleccionada}
                                  onChange={e => setOficinaSeleccionada(e.target.value)}
                                >
                                  <option value="">Seleccione una oficina</option>
                                  {Oficinas.map((of, idx) => (
                                    <option key={idx} value={of.clave}>
                                      {of.clave} - {of.descripcion}
                                    </option>
                                  ))}
                                </select>
                            </div>
                        </div>
                        {/* Renglon #2 */}
                        <div className="row mb-3">
                          <div className="col-md-3">
                            <label>Canal</label>
                            <select
                                  className={`form-control ${errors.tipoActividadSeleccionada ? 'is-invalid' : ''}`}
                                  value={tipoActividadSeleccionada}
                                  onChange={e => {
                                      setTipoActividadSeleccionada(e.target.value);
                                      setActividadSeleccionada("");
                                  }}
                                >
                                <option value="">Seleccione un tipo</option>
                                <option value="T">Tradicional</option>
                                <option value="P">Canal Propio</option>
                                <option value="G">Grupo</option>
                            </select>
                          </div>
                            <div className="col-md-6">
                                <label>Actividad</label>
                                <select
                                  className={`form-control ${errors.actividadSeleccionada ? 'is-invalid' : ''}`}
                                  value={actividadSeleccionada}
                                  onChange={e => setActividadSeleccionada(e.target.value)}
                                  disabled={!tipoActividadSeleccionada}
                                >
                                  <option value="">Seleccione una Actividad</option>
                                  {actividadesFiltradas.map((of, idx) => (
                                    <option key={idx} value={of.idActividad}>
                                      {of.idActividad} - {of.actividad}
                                    </option>
                                  ))}
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label>Fecha de Actividad</label>
                                <DatePicker
                                    selected={fechaActividad}
                                    onChange={date => setFechaActividad(date)}
                                    className={`form-control w-100 ${errors.fechaActividad ? 'is-invalid' : ''}`}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Selecciona una fecha"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={30}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                        {/* Renglon #3 */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label>Promotor / Agente {!esActividadOpcional && <span className="text-danger">*</span>}</label>
                                <select 
                                  className={`form-control ${errors.agentePromotor ? 'is-invalid' : ''}`}
                                  value={agentePromotor || ""}
                                  onChange={e => {
                                      setagentePromotor(e.target.value);
                                      setAgenteSeleccionado(null);
                                      setPromotorSeleccionado(null);
                                      setClaveAgente("");
                                  }}
                                  disabled={!actividadSeleccionada}
                                >
                                    <option value="">Seleccione una opcion</option>
                                    {esActividadOpcional && <option value="0">No Aplica</option>}
                                    <option value="1">Promotor</option>
                                    <option value="2">Agente</option>
                                </select>
                            </div>
                            <div className="col-md-5">
                                <label>Nombre del {agentePromotor === "1" ? "Promotor" : "Agente"}</label>
                                <Select
                                    isDisabled={agentePromotor === "0" || !agentePromotor}
                                    options={agentePromotor === "1" ? Promotores.map(p => ({
                                        value: p.codInter,
                                        label: p.nombre,
                                        rfc: p.rfc
                                    })) : Agentes.map(a => ({
                                        value: a.codInter,
                                        label: a.nombre,
                                        rfc: a.rfc
                                    }))}
                                    className={`basic-single ${errors.personaSeleccionada ? 'is-invalid' : ''}`}
                                    classNamePrefix="select"
                                    placeholder={agentePromotor === "0" ? "No Aplica" : "Buscar..."}
                                    isClearable
                                    onChange={selected => {
                                        if (agentePromotor === "1") {
                                            setPromotorSeleccionado(selected);
                                        } else {
                                            setAgenteSeleccionado(selected);
                                        }
                                        setClaveAgente(selected ? selected.value : "");
                                    }}
                                    value={agentePromotor === "1" ? promotorSeleccionado : agentePromotor === "2" ? agenteSeleccionado : null}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Clave</label>
                                <input type="text" className="form-control" value={claveAgente} readOnly />
                            </div>
                        </div>
                        {/* Renglon #4 */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label>Tipo de contacto</label>
                            <select 
                              className={`form-control ${errors.TipoContactoSeleccionado ? 'is-invalid' : ''}`}
                              value={TipoContactoSeleccionado}
                              onChange={e => setTipoContactoSeleccionado(e.target.value)} >
                             <option value="">Seleccione un tipo de contacto</option>
                                {tipoContacto.map((tc, idx) => (
                              <option key={idx} value={tc.idTipoContacto}>
                                {tc.tipoContacto}
                              </option>
                                            ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label>Motivo de contacto</label>
                            <input
                              type="text"
                              maxLength={50}
                              className={`form-control ${errors.motivoContacto ? 'is-invalid' : ''}`}
                              value={motivoContacto}
                              onChange={e => setMotivoContacto(e.target.value)}
                            />
                            <div className="text-end text-muted" style={{ fontSize: '0.85rem' }}>
                              {motivoContacto.length} / 50
                            </div>
                          </div>
                        </div>
                        {/* Renglon #5 */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label>Persona de contacto</label>
                            <input
                              type="text"
                              maxLength={50}
                              className="form-control"
                              value={personaContacto}
                              onChange={e => setPersonaContacto(e.target.value)}
                            />
                            <div className="text-end text-muted" style={{ fontSize: '0.85rem' }}>
                              {personaContacto.length} / 50
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label>Puesto de Contacto</label>
                            <input
                              type="text"
                              maxLength={50}
                              className="form-control"
                              value={puestoContacto}
                              onChange={e => setPuestoContacto(e.target.value)}
                            /> 
                            <div className="text-end text-muted" style={{ fontSize: '0.85rem' }}>
                              {puestoContacto.length} / 50
                            </div>
                          </div>
                        </div>
                        {/* Renglon #6 */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label>Hora de Contacto</label>
                            <input
                              type="time"
                              className={`form-control ${errors.horaContacto ? 'is-invalid' : ''}`}
                              value={horaContacto}
                              onChange={e => setHoraContacto(e.target.value)}
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Duración de Contacto</label>
                            <select
                              className={`form-control ${errors.duracionSeleccionada ? 'is-invalid' : ''}`}
                              value={duracionSeleccionada || ""}
                              onChange={e => setDuracionSeleccionada(e.target.value)}
                            >
                              <option value="">Seleccione una duración</option>
                              {duraciones.map((d, idx) => (
                                <option key={idx} value={d.idDuracion}>
                                  {d.duracion}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <br /> <br />
                        {/* Renglon #7 */}
                        <div className="row mb-3">
                            <div className="col-md-10">
                                <label>Acuerdos</label>
                            </div>
                            <div className="d-flex align-items-end col-md-2">
                                {mostrarAcuerdo ? (
                                  <i
                                    className="bi bi-dash-circle"
                                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                                    onClick={() => setMostrarAcuerdo(false)}
                                  ></i>
                                ) : (
                                  <i
                                    className="bi bi-plus-circle"
                                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                                    onClick={() => setMostrarAcuerdo(true)}
                                  ></i>
                                )}
                            </div>
                        </div>
                        
                        {/* Renglon #8 solo si mostrarAcuerdo es true, con transición */}
                        <div className={`row mb-3 transicion-campo${mostrarAcuerdo ? " mostrar" : ""}`}>
                          <div className="col-md-6">
                            <label>Tipo de Acuerdo</label>
                            <select
                              className="form-control"
                              value={tipoAcuerdoSeleccionado || ""}
                              onChange={e => setTipoAcuerdoSeleccionado(e.target.value)}
                            >
                              <option value="">Seleccione un tipo de acuerdo</option>
                              {tipoAcuerdo.map((ta, idx) => (
                                <option key={idx} value={ta.idAcuerdo}>
                                  {ta.acuerdo}
                                </option>
                              ))}
                            </select>
                            {mensajeAcuerdo && (
                            <div className="alert alert-warning mt-2 py-1 px-2">
                                {mensajeAcuerdo}
                            </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label>Fecha Compromiso</label>
                            <DatePicker
                                selected={fechaCompromisoAgregar}
                                onChange={date => setFechaCompromisoAgregar(date)}
                                className="form-control w-100"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Selecciona una fecha"
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={30}
                            />
                          </div>
                          <div className="col-md-2 d-flex align-items-end">
                            <button
                              type="button"
                              className="btn btn-success w-100"
                              disabled={!tipoAcuerdoSeleccionado}
                              onClick={agregarAcuerdo}
                            >
                              Agregar
                            </button>
                          </div>
                        </div>

                        {/* Tabla de acuerdos, solo si hay al menos uno */}
                        {acuerdos.length > 0 ? (
                          <div className="row mb-3">
                            <div className="col-md-12">
                              <table className="table table-bordered table-md">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Tipo de Acuerdo</th>
                                    <th>Comentario</th>
                                    <th>Fecha Compromiso</th>
                                    <th>Acción</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {acuerdos.map((a, idx) => (
                                    <tr key={a.idAcuerdo}>
                                      <td>{idx + 1}</td>
                                      <td>{a.acuerdo}</td>
                                      <td>
                                        <input
                                          type="text" className="form-control" placeholder="Comentario (opcional)"
                                          style={{ fontSize: "0.8rem", padding: "2px 8px" }}
                                          value={a.comentarioAcuerdo}
                                          onChange={e => {
                                            const nuevosAcuerdos = [...acuerdos];
                                            nuevosAcuerdos[idx].comentarioAcuerdo = e.target.value;
                                            setAcuerdos(nuevosAcuerdos);
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <DatePicker
                                          selected={a.fechaCompromiso}
                                          onChange={date => {
                                            const nuevosAcuerdos = [...acuerdos];
                                            nuevosAcuerdos[idx].fechaCompromiso = date;
                                            setAcuerdos(nuevosAcuerdos);
                                          }}
                                          className="form-control"
                                          dateFormat="dd/MM/yyyy"
                                          placeholderText="Fecha"
                                          showYearDropdown
                                          scrollableYearDropdown
                                          yearDropdownItemNumber={30}
                                          style={{ fontSize: "0.8rem", padding: "2px 8px" }}
                                        />
                                      </td>
                                      <td>
                                        <button type="button" className="btn btn-danger btn-sm"
                                          onClick={() => quitarAcuerdo(idx)} >
                                          Quitar
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <div className="alert alert-info">
                                        No se ha declarado ningún acuerdo.
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Renglon #9 */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                              <label>Comentarios (Opcional)</label>
                              <textarea
                                className="form-control textarea"
                                rows="4"
                                maxLength={1000}
                                value={comentarios}
                                onChange={e => setComentarios(e.target.value)}
                              />
                              <div className="text-end text-muted" style={{ fontSize: "0.95rem" }}>
                                {1000 - comentarios.length} / 1000 
                              </div>
                            </div>
                        </div>
                        {/* Botón de Guardar Bitácora */}
                        <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary">
                                Guardar Bitácora
                            </button>
                        </div>
                    </form>

                </main>
            </div>
        </LayoutGeneral>
    );
};

export default BitacoraNueva_Seguimiento;